/*
 * File: updatePillBoxDetail.tsx
 * Project: meki
 * File Created: Tuesday, 25th January 2022 4:06:36 pm
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Monday, 16th January 2023 3:23:48 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2022 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */
import { PillBoxDetail } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';
import { gql } from '@apollo/client';

export const UpdatePillBoxDetailMutation = () => gql`
  mutation updatePillBoxDetail($params: UpdatePillBoxDetailParams!) {
    updatePillBoxDetail(params: $params) {
      id
      lastMovementBalance
      userStock
      frequency
      remainingBalanceDays
      lastOrderDate
      speedConsumption
      consumptionUnit
      fewPills
      stillHave
      allowedFormat
      hidden
    }
  }
`;

export type UpdatePillBoxDetailMutationParams = ResolverParams<{
  productSlug: string;
  consumptionUnit?: number;
  frequency?: number;
}>;

export type UpdatePillBoxDetailResponse = {
  updatedPillBoxDetail: PillBoxDetail;
};
